import { render, staticRenderFns } from "./RacialTraitsPanel.vue?vue&type=template&id=cb3ffd02"
import script from "./RacialTraitsPanel.vue?vue&type=script&lang=js"
export * from "./RacialTraitsPanel.vue?vue&type=script&lang=js"
import style0 from "./RacialTraitsPanel.vue?vue&type=style&index=0&id=cb3ffd02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports